import * as _ from 'lodash';
import React from 'react';
import { Col } from 'react-bootstrap';

const renderBreadCrumb = (breadCrumbName) => {
  if (breadCrumbName) {
    const arrBrdCrumb = breadCrumbName.toUpperCase().split('>');
    if (arrBrdCrumb.length === 1) {
      return <b> {_.last(arrBrdCrumb)}</b>;
    }
    const first = arrBrdCrumb.slice(0, -1).join('>');
    return (
      <span>
        {`${first} >`}
        <b> {_.last(arrBrdCrumb)}</b>
      </span>
    );
  }
  return '';
};

const Breadcrumb = ({ breadCrumbName, style }) => (
  <Col lg={12} style={style}>
    {renderBreadCrumb(breadCrumbName)}
  </Col>
);

export default React.memo(Breadcrumb);
